export default function StickyMenu(selector = ".aai-sticky") {
  const handleScroll = () => {
    const element = document.querySelector(selector);
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.classList.add("sticky");
      } else {
        element.classList.remove("sticky");
      }
    }
  };

  document.addEventListener("scroll", handleScroll);

  return () => {
    document.removeEventListener("scroll", handleScroll);
  };
}
